import React from "react";
import Header from "../Header/Header";

const Mentions = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Mentions légales
          </h1>

          <div className="space-y-8">
            {/* Données personnelles */}
            <section className="border-l-4 border-orange-500 pl-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                Protection des données
              </h2>

              <p className="text-gray-600 leading-relaxed mb-4">
                Vous disposez d’un droit d’accès, de modification, de
                rectification et de suppression des données qui vous concernent
                conformément à la réglementation en vigueur.
              </p>

              <p className="text-gray-600 leading-relaxed">
                Pour exercer ce droit, adressez-vous à ALFenvironnement,
                28 Chemin de Muret, 31410 Longages ou contactez-nous par email.
              </p>
            </section>

            {/* Éditeur */}
            <section className="bg-gray-50 rounded-2xl p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                Édition du site
              </h2>

              <p className="text-gray-600 leading-relaxed">
                Le site
                <span className="font-medium text-gray-800">
                  {" "}
                  aigaflow.dev.alf-environnement.net
                </span>{" "}
                est édité par la société ALFenvironnement.
              </p>
            </section>

            {/* Responsable */}
            <section className="bg-gray-50 rounded-2xl p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                Responsable de publication
              </h2>

              <p className="text-gray-600 leading-relaxed">
                Christophe ARNOULD
              </p>
            </section>

            {/* Hébergement */}
            <section className="bg-gray-50 rounded-2xl p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Hébergement
              </h2>

              <div className="space-y-2 text-gray-600">
                <p>
                  Le site est hébergé par Google Cloud Platform à Paris.
                </p>

                <p>
                  <span className="font-medium text-gray-800">Adresse :</span>{" "}
                  Google France, 8 rue de Londres, 75009 Paris
                </p>

                <p>
                  <span className="font-medium text-gray-800">Téléphone :</span>{" "}
                  01 42 68 53 00
                </p>
              </div>
            </section>

            {/* Contact */}
            <section className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                Contact
              </h2>

              <p className="text-gray-600">
                Pour toute question ou demande d'information :
              </p>

              <a
                href="mailto:contact@alf-environnement.com"
                className="inline-flex mt-3 text-lg font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors"
              >
                contact@alf-environnement.com
              </a>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : 17/07/2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mentions;